var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconIceSymbol10 = function SvgIconIceSymbol10(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-blue700, #1127E9)",
    fillRule: "evenodd",
    d: "M4.455 9.545V.455h1.09v9.09z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-blue700, #1127E9)",
    fillRule: "evenodd",
    d: "M8.664 7.745.79 3.2l.545-.945L9.21 6.8z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-blue700, #1127E9)",
    fillRule: "evenodd",
    d: "M1.336 7.745 9.21 3.2l-.545-.945L.79 6.8z",
    clipRule: "evenodd"
  })));
};
export default SvgIconIceSymbol10;